import React from "react";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";

const CHIP_CONFIG = [
  { key: "total",          label: "Participants",       color: "#00ff90"  },
  { key: "completion",     label: "Completion %",       color: "#60a5fa", suffix: "%" },
  { key: "avgRating",      label: "Avg Rating",         color: "#fbbf24"  },
  { key: "selfPending",    label: "Self Pending",       color: "#f87171"  },
  { key: "mgrPending",     label: "Mgr Pending",        color: "#fb923c"  },
  { key: "calibrationItems",label: "Calibration Items", color: "#c084fc"  },
];

export default function PerformanceKpis({ loading, kpis, completion, avgRating, total }) {
  // Support both flat props (legacy) and kpis object
  const data = kpis || { total, completion, avgRating };

  return (
    <div className={`${card} p-5`}>
      <div className="grid grid-cols-2 md:grid-cols-6 gap-3">
        {CHIP_CONFIG.map(({ key, label, color, suffix = "" }) => (
          <div key={key} className="rounded-lg border border-white/5 bg-white/3 p-3 text-center">
            {loading ? (
              <div className="h-6 rounded bg-white/10 animate-pulse mb-1" />
            ) : (
              <p className="text-lg font-bold" style={{ color }}>
                {data[key] != null ? `${data[key]}${suffix}` : "—"}
              </p>
            )}
            <p className="text-xs text-white/30 mt-0.5">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}